import { NotificationManager } from "react-notifications";
import { api } from "api";
import { useDispatch } from "react-redux";

const baseurl = "laboratorio/empresa";
const writeSuccessMsg = "Empresa agregada";
const editSuccessMsg = "Empresa editada";

export const getList = () => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let empresa = id_emp[5];
    const params = { empresa };
    return api
        .get(baseurl, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error)
            return [];
        });
};

export const getEntry = (id) => {

    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let empresa = id_emp[5];
    const params = { empresa };
    // const url = id? baseurl + `/${id}`: baseurl;
    return api
        .get(baseurl, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error)
            return null;
        });
};

export const crear = (data) => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    const formData = {
        ...data,
        empresa: id_emp[5],
    };
    return api
        .post(baseurl, formData)
        .then(() => {
            NotificationManager.success(writeSuccessMsg, "Exito", 3000);
        })
        .catch((error) => {
            NotificationManager.error("", "Error", 2000);
        });
};

export const editar = (data, id) => {
    let ruta = window.location.href;
    let empresa = ruta.split("/")[5];
    const formData = {
        ...data,
        empresa,
    };
    return api
        .put(baseurl + `/${id}`, formData)
        .then(() => {
            NotificationManager.success(editSuccessMsg, "Exito", 3000);
            return true;
        })
        .catch((error) => {
            try {
                error.non_field_errors.map((err) => {
                    NotificationManager.error(err, "Error", 10000);
                });
                return
            } catch (exception){
                Object.keys(error).forEach((field) => {
                    error[field].forEach((errorMessage) => {
                        NotificationManager.error(`${field}: ${errorMessage}`, "Error", 10000);
                    });
                });
            } 
            
            console.log(error)
            NotificationManager.error("", "Error", 10000);
            return null
        });
};
